import {combineReducers} from 'redux'
import types from 'actions/types'

const activities = (state = [], action) => {
  switch (action.type) {
    case types.DIARY_LOAD_ACTIVITY_THREAD_SUCCESS:
      return action.data
    case types.DIARY_LOAD_ACTIVITY_THREAD_FAILURE: return []
    case types.HIDE_ACTIVITY_DIALOG: return []
    default: return state
  }
}

export default combineReducers({
  activities,
})
